import React, { Component } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js'
import { Link } from 'react-router-dom';
import Modal from '../../helper/modal';
import {setMarket} from '../../../actions/ui/marketplace';
import {collateralizeFilterDispatch,filterHistoricalOrdersDispatch} from '../../../actions/orderbook/filter';
import Help from "../../helper/help";
import TableHeader from '../../helper/tableHeader';
import {withRouter} from 'react-router-dom';
import {pairs} from '../../../config';
import './marketPicker.css';
import $ from 'jquery';
import PropTypes from 'prop-types';

class MarketPicker extends Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(){
    super()
    this.state = {filter:'',type:'bid/ask'}
  }
  componentDidMount(){
    let type = this.props.location.hash ? this.props.location.hash.substring(1) : null;
    let {pairs} = require('../../../config')

    if(type && Object.keys(pairs).includes(type)){
      this.setState({type})
    }
  }
  async setUrl({denomination,asset}){
    let _this = this;
    this.props.history.push({search:`${asset}/${denomination}`,hash:this.state.type})
    await _this.props.setMarket({asset,denomination,type:this.state.type})
    setTimeout(async ()=>{
      await this.props.collateralizeFilterDispatch()
    },100)
  }
  renderItems(pairs){
    return pairs.map((p)=>{
      let id = `${p.asset}/${p.denomination}`
      let opacity = this.props.text === id ? '1' : '0.5'
      return (
        <tr id={id} key={id} style={{opacity,cursor:'pointer'}} onClick={this.setUrl.bind(this,p)} >
          <td className='marketItem' >{id}</td>
          <td className='marketItem' >{p.lastPrice.price != 0 ? p.lastPrice.price.toString().substring(0,10) : '-'}</td>
          <td className='marketItem' >{p.volume != 0 ? p.volume.toString().substring(0,10) : '-'}</td>
        </tr>
      )
    })
  }
  render(){
    let pairs = this.props.pairs[this.state.type]
    if(this.state.filter.length > 0){
      let needle
      if (this.state.filter.includes('/')) {
        needle = this.state.filter.toLowerCase().split('/', 2)
      } else {
        needle = this.state.filter.toLowerCase()
      }
      pairs = pairs.filter(p => {
        if (Array.isArray(needle)) {
          const [d, a] = needle
          return p['asset'].toLowerCase().includes(d) && p['denomination'].toLowerCase().includes(a)
        } else {
          return p['denomination'].toLowerCase().includes(needle) || p['asset'].toLowerCase().includes(needle)
        }
      })
    }
    
    let titles = [
      'Bid/Ask',
      'Auction',
      // 'Leases'
    ]

    return (
      <div>
        <div className="col s12" style={{margin:0,color:'white'}}>
          <h6>Market Picker</h6>
        </div>
        <div className='col s12 section'>

          <div className='col s12'>
            <div className='col s4' style={{padding:0,borderBottom:'1px solid grey',height:'25.5px'}}>
              <i className='material-icons searchIcon'>search</i>
              <input id='searchMarkets' type='text' placeholder='Search' onChange={this.handleChange.bind(this)} />
            </div>

            <div className='col s8' style={{padding:0,borderBottom:'1px solid grey',borderLeft:'1px solid grey'}}>
              {titles.map((title)=>(
                <div className={`col s${12/ titles.length} center`} style={{padding:0,color:this.state.type == title.toLowerCase() ? 'white' : 'grey'}}>
                  <h6 className='marketType' onClick={this.setType.bind(this,title.toLowerCase())}>{title}</h6>
                </div>
              ))}

            </div>
          </div>

          <TableHeader items={['Pair','Price','Volume']} fontSize={'12px'}/>
          <div className='col s12 marketPicker'>
            <table className="white-text order-book marketTable">
              <tbody>
                {this.renderItems(pairs)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
  setType(type){
    this.setState({type})
  }
  handleChange(event){
    this.setState({filter:event.target.value})

  }
}

function mapStateToProps(state,props) {
  return {
    pairs: state.orderbook.matched_pairs,
    stats: state.orderbook.stats && state.orderbook.stats['ETH/BTC'] ? state.orderbook.stats : {},
    text:`${state.ui_marketplace.market.asset}/${state.ui_marketplace.market.denomination}`
  };
}

export default connect(mapStateToProps, {setMarket,
  filterHistoricalOrdersDispatch,
  collateralizeFilterDispatch
})(withRouter(props => <MarketPicker {...props}/>));
